<script setup>
import moment from "moment";

const year = moment().year();
const site = useState("site");
</script>

<template lang="pug">
div(v-if="site")
  AppContainer(slim)
    .text-hint-500.text-center.py-2.mt-8
      .my-4 竞赛相关工具：
        a.link-underline(href="/timer", target="_blank") 大赛计时器
      div 版权所有 &copy; {{ year }} {{ site.title }}
      div(v-if="site && site.ownerName") 本届大赛主办方：{{ site.ownerName }}
      div(v-if="site && site.hostName") 本届大赛承办方：{{ site.hostName }}
      div(v-if="site && site.sponsorName") 本届大赛协办方：{{ site.sponsorName }}
      div
        Beian
      .text-hint-400 本网站建议使用Google Chrome、Firefox浏览器、1366*768以上分辨率浏览。
</template>

<style lang="scss" scoped>
a.link-underline {
  text-decoration: underline;
}
</style>
